// Adapted from the UI prototype's Radix indigo/slate scales. Keep these framework-independent.
export const helixTokens = {
  color: {
    light: {
      background: {
        canvas: '#F9F9FB',
        surface: '#FFFFFF',
        subtle: '#FCFCFD',
        muted: '#F0F0F3',
        sunken: '#E8E8EC',
      },
      border: { default: '#E0E1E6', strong: '#CDCED6' },
      text: { primary: '#1C2024', secondary: '#60646C', tertiary: '#8B8D98', inverse: '#FFFFFF' },
      primary: {
        main: '#3E63DD',
        strong: '#3358D4',
        text: '#3A5BC7',
        solid: '#3E63DD',
        solidHover: '#3358D4',
        soft: '#EDF2FE',
        softer: '#F7F9FF',
        ring: 'rgba(62,99,221,.24)',
      },
      semantic: {
        // Slightly deeper text tones keep small badges readable on their soft backgrounds.
        success: { main: '#1E7850', soft: '#E6F6EB' },
        warning: { main: '#9D5C00', soft: '#FFF7C2' },
        danger: { main: '#CE2C31', soft: '#FEEBEC' },
        info: { main: '#0B6ABD', soft: '#E6F4FE' },
      },
    },
    dark: {
      background: {
        canvas: '#18191B',
        surface: '#212225',
        subtle: '#111113',
        muted: '#272A2D',
        sunken: '#111113',
      },
      border: { default: '#363A3F', strong: '#43484E' },
      text: { primary: '#EDEEF0', secondary: '#B0B4BA', tertiary: '#777B84', inverse: '#FFFFFF' },
      primary: {
        main: '#9EB1FF',
        strong: '#D6E1FF',
        text: '#9EB1FF',
        solid: '#3E63DD',
        solidHover: '#3358D4',
        soft: '#182449',
        softer: '#141726',
        ring: 'rgba(158,177,255,.30)',
      },
      semantic: {
        success: { main: '#3DD68C', soft: '#132D21' },
        warning: { main: '#FFCA16', soft: '#302008' },
        danger: { main: '#FF9592', soft: '#3B1219' },
        info: { main: '#70B8FF', soft: '#0D2847' },
      },
    },
    priority: {
      urgent: { main: '#CE2C31', soft: '#FEEBEC' },
      high: { main: '#CC4E00', soft: '#FFEFD6' },
      medium: { main: '#AB6400', soft: '#FFF7C2' },
      low: { main: '#60646C', soft: '#F0F0F3' },
    },
    channel: {
      whatsapp: '#1FA855',
      chat: '#3A5BC7',
      email: '#8145B5',
      call: '#008573',
      social: '#C13584',
    },
  },
  radius: { xs: 3, sm: 4, md: 8, lg: 12, xl: 16, full: 999 },
  control: { small: 24, medium: 32, large: 40, icon: 32 },
  space: { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 },
  layout: {
    sidebar: 248,
    sidebarCollapsed: 68,
    header: 60,
    desktopMinWidth: 1025,
    contentMaxWidth: 1480,
  },
  motion: {
    fast: 160,
    medium: 320,
    slow: 500,
    press: 120,
    rowHover: 140,
    page: 220,
    panel: 260,
    layout: 300,
    reveal: 320,
    stagger: 40,
    count: 900,
    standard: 'cubic-bezier(.32,.72,0,1)',
    emphasized: 'cubic-bezier(.16,1,.3,1)',
  },
  typography: {
    sans: '"IBM Plex Sans", "IBM Plex Sans Arabic", system-ui, -apple-system, "Segoe UI", sans-serif',
    arabic: '"IBM Plex Sans Arabic", "IBM Plex Sans", system-ui, sans-serif',
    mono: '"IBM Plex Mono", ui-monospace, "SFMono-Regular", monospace',
    size: { caption: 12, body: 14, lead: 16, heading: 20, title: 24 },
  },
} as const;

export type HelixMode = 'light' | 'dark';
export type HelixDirection = 'ltr' | 'rtl';
